// Libraries
import styled from "styled-components"


export const VentureGeneralInfoContainer = styled.div`

`

